// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import IconButton from './ClientIconButton'
import { headlessIconButtonProps } from './IconButton'
export * from './types'
export { IconButton, headlessIconButtonProps }
